import React, { useEffect, useState, useRef } from "react";
import { Alert, Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import socketIO from "../../helpers/socket";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { getNotification as onGetNotifications, addNewNotification as onAddNewNotification, updateNotification as onUpdateNotification, deleteNotification as onDeleteNotification, getNotificationLoading, setReadNotification as onSetReadNotification } from "../../store/notification/action";
import PropTypes from "prop-types";
import withRouter from "../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import sound from "../../assets/notif.mp3";
import sound2 from "../../assets/akhh.mp3";

//SimpleBar
import SimpleBar from "simplebar-react";
import moment from "moment";
const io = socketIO.getInstance();
io.setHost("https://api-pkn.pkdeveloper.id");
const socket = io.getSocket();

const NotificationDropdown = (props) => {
  const { t } = props;
  const audioRef = useRef(null);
  const audioRef2 = useRef(null);
  const toastId = useRef(null);

  const [notificationEvent, setNotificationEvent] = useState([]);
  const dispatch = useDispatch();
  const { notifications, isNotificationCreated, isNotificationSuccess, loading, error } = useSelector((state) => ({
    notifications: state.Notification.notifications,
    isNotificationCreated: state.Notification.isNotificationCreated,
    isNotificationSuccess: state.Notification.isNotificationSuccess,
    loading: state.Notification.loading,
    error: state.Notification.error,
  }));

  const [isSearch, setIsSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState(false);

  const [notificationList, setNotificationList] = useState([]);
  const [alertList, setAlertList] = useState([]);
  const [notifList, setNotifList] = useState([]);
  const [notification, setNotification] = useState([]);
  const [notificationOpt, setNotificationOpt] = useState(true);
  const [counter, setCounter] = useState(0);
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setUserId(obj?.data?.userId);
    const notification = localStorage.getItem("NOTIFICATION_OPTION") ? localStorage.getItem("NOTIFICATION_OPTION").toLowerCase() === 'true' : true;
    if (notification)
    {
      setNotificationOpt(true);
      localStorage.setItem("NOTIFICATION_OPTION", true);
    }
    else
    {
      setNotificationOpt(false);
      localStorage.setItem("NOTIFICATION_OPTION", false);

    }
  }, []);

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const durationnotify = (message) => toastId.current = toast(message, { position: "top-right", autoClose: 2000, hideProgressBar: false, className: 'bg-info text-white', id: 'notif' });

  useEffect(() => {
    function onConnect() {
      //setIsConnected(true);
    }

    function onDisconnect() {
      //setIsConnected(false);
    }

    function onFooEvent(value) {
      const notification = localStorage.getItem("NOTIFICATION_OPTION") ? localStorage.getItem("NOTIFICATION_OPTION").toLowerCase() === 'true' : true;
      if (notification) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        //const findUser = value?.notification_user?.find((d) => d.userId === obj?.data?.userId);
        // if (findUser) {

        // }
        if (obj?.data?.userId === 5237) {
          if (audioRef2.current) audioRef2.current.play().catch(error => { console.error("Audio play failed:", error) });
        }
        else {
          if (audioRef.current) audioRef.current.play().catch(error => { console.error("Audio play failed:", error) });
        }

        //toast.dismiss(toastId.current);
        durationnotify(value?.message)
        //setNotificationEvent((previous) => [...previous, value]);
      }
      setNotification(value);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("erp_notification", onFooEvent);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("foo", onFooEvent);
    };
  }, []);

  useEffect(() => {
    let arr = [];
    let counter = 0;
    for (const n of notifications) {
      counter++;
      //if (counter < 11 && n?.notification_user?.[0]?.hasRead === false)
      if (counter < 10)
        arr.push(n);
    }
    setNotificationList(arr);
    setCounter(notifications.filter((notif) => notif.notification_user?.[0]?.hasRead === false).length)
  }, [notifications]);

  useEffect(() => {
    let arr = [notification];
    let counter = 1;
    for (const n of notificationList) {
      counter++;
      //if (counter < 10 && n?.notification_user?.[0]?.hasRead === false)
      if (counter < 10)
        arr.push(n);
    }
    setCounter(counter)
    setNotificationList(arr);
  }, [notification]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(onGetNotifications({ limit: 10 }));
    }
    setIsSearch(true);
  }, [dispatch, isSearch]);

  return (
    <React.Fragment>
      <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
        <audio ref={audioRef} src={sound} />
        <audio ref={audioRef2} src={sound2} />

        <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none">
          <i className="bx bx-bell fs-22"></i>
          <span className={counter > 0 ? "position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger" : "position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-light"}>
            {counter >= 10 ? ">10" : counter}
            <span className="visually-hidden">{t("unread messages")}</span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    <input
                  type="checkbox"
                  className="dataCheckbox me-2 form-check-input"
                  checked={notificationOpt}
                  onChange={() => {
                    if (notificationOpt) {
                      setNotificationOpt(false);
                      localStorage.setItem("NOTIFICATION_OPTION", false);
                    }
                    else {
                      setNotificationOpt(true);
                      localStorage.setItem("NOTIFICATION_OPTION", true);
                    }
                  }} />
                    {t("Notifications")}
                    </h6>
                </Col>
                <div className="col-auto dropdown-tabs">
                  <span className="badge badge-soft-warning fs-12">
                    {counter >= 10 ? ">10" : counter} {t("Unreads")}
                  </span>
                </div>
              </Row>
            </div>

            {/* 
            <div className="px-2 pt-2">
              <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}>
                    {t("All")} ({notificationList.length})
                  </NavLink>
                </NavItem><NavItem>
                  <NavLink
                    href='#'
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}>
                    {t("General")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href='#'
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}>
                    {t("Alerts")}
                  </NavLink>
                </NavItem> 
              </Nav>
            </div>*/}
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {(notificationList || []).map((element) => {
                  if (element.type === "alert") {
                    alertList.push(element);
                  } else {
                    notifList.push(element);
                  }
                  return (
                    <div key={"notification" + element.id} className="text-reset notification-item d-block dropdown-item position-relative">
                      <div className="d-flex">
                        <div className="flex-1">
                          <Link to="#" className="stretched-link">
                            <h6 className="mt-0 mb-1 lh-base">{element.name}</h6>
                          </Link>
                          <p className="mb-2 fs-11 fw-medium text-muted">{element.message}</p>
                          <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i> {moment(element.createdat).fromNow()}
                            </span>
                          </p>
                        </div>
                        <div className="px-2 fs-15" style={{ width: "25px" }}>
                          <div className="form-check notification-check">
                            <input
                              onChange={() => {
                                const userNotificationId = element.notification_user?.[0]?.id;
                                if (userNotificationId) {
                                  dispatch(onSetReadNotification({ id: userNotificationId, notifId: element.id }));
                                }
                              }}
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="all-notification-check01" />
                          </div>
                          {/* <input className="form-check-input" type="checkbox" /> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </SimpleBar>
              <div className="my-3 text-end">

                <Link to="/notif" className="btn btn-soft-success waves-effect waves-light me-3">
                  {t("View All")}
                  <i className="ri-arrow-right-line align-middle"></i>
                </Link>
                {counter > 0 && <button
                  type="button"
                  className={"btn btn-soft-info add-btn me-3"}
                  id="create-btn"
                  onClick={() => {
                    dispatch(onSetReadNotification({ id: "all", notifId: "all" }));
                  }}>Set Read
                </button>}

              </div>
            </TabPane>

            <TabPane tabId="2" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "500px" }} className="pe-2">
                {(notifList || []).map((element, elementIdx) => {
                  return (
                    <div key={"notiflist" + elementIdx} className="text-reset notification-item d-block dropdown-item position-relative">
                      <div className="d-flex">
                        <div className="flex-1">
                          <Link to="#" className="stretched-link">
                            <h6 className="mt-0 mb-1 lh-base">{element.name}</h6>
                          </Link>
                          <p className="mb-2 fs-11 fw-medium text-muted">{element.message}</p>
                          <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>
                              {moment(element.createdat).fromNow()}
                            </span>
                          </p>
                        </div>
                        <div className="px-2 fs-15">
                          <div className="form-check notification-check">
                            <input className="form-check-input" type="checkbox" value="" id="all-notification-check01" />
                            <label className="form-check-label" htmlFor="all-notification-check01"></label>
                          </div>
                          {/* <input className="form-check-input" type="checkbox" /> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </SimpleBar>

              <div className="my-3 text-center">
                <button type="button" className="btn btn-soft-success waves-effect waves-light">
                  {t("View All Messages")}
                  <i className="ri-arrow-right-line align-middle"></i>
                </button>
              </div>
            </TabPane>
            <TabPane tabId="3" className="p-4">
              {(alertList || []).map((element) => {
                return (
                  <div key={"alertlist" + element.id} className="text-reset notification-item d-block dropdown-item position-relative">
                    <div className="d-flex">
                      <div className="flex-1">
                        <Link to="#" className="stretched-link">
                          <h6 className="mt-0 mb-1 lh-base">{element.name}</h6>
                        </Link>
                        <p className="mb-2 fs-11 fw-medium text-muted">{element.message}</p>
                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                          <span>
                            <i className="mdi mdi-clock-outline"></i>
                            {moment(element.createdat).fromNow()}
                          </span>
                        </p>
                      </div>
                      <div className="px-2 fs-15">
                        <div className="form-check notification-check">
                          <input className="form-check-input" type="checkbox" value="" id="all-notification-check01" />
                          <label className="form-check-label" htmlFor="all-notification-check01"></label>
                        </div>
                        {/* <input className="form-check-input" type="checkbox" /> */}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="text-center pb-5 mt-2">
                <h6 className="fs-18 fw-semibold lh-base">{t("Hey! You have no any notifications")}</h6>
              </div>
            </TabPane>
          </TabContent>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

NotificationDropdown.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(NotificationDropdown));
